<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {RouterLink} from 'vue-router';
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  search: null,
  dataLoading: true,
  newAdj: false,
  headers: [
    { title: 'Claim Number', key: 'claimnumber' },
    { title: 'Client', key: 'clientname' },
    { title: 'Insured', key: 'insuredname' },
    { title: 'Adjuster', key: 'personname' },
    { title: 'Date Started', key: 'datestarted' },
  ],
  items: [],
});

const getData = () => {
  
  if (props.contextSchemaA === 'person') {
    ApiWrapper.post('claims', 'claim-list-person', {
          personId: props.contextIdA,
        })
        .then((response) => {
          if(response){
            if(response.claims){
              data.items = response.claims;
            }
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false;
        })
  } else if (props.contextSchemaA === 'clients') {
    ApiWrapper.post('claims', 'claim-list-client', {
          clientId: props.contextIdA,
        })
        .then((response) => {
          if(response.claims){
            data.items = response.claims;
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.dataLoading = false;
        })
  } else {
    ApiWrapper.get('claims', 'claim-list').then((response) => {
        if(response.claims){
          data.items = response.claims;
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false;
      })
  }
}

onMounted(()=>{
  getData();
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Open Claims</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="4">
          <v-text-field
              v-model="data.search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="ml-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          item-value="claimid"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{ item.claimnumber }}
          </RouterLink>
        </template>
        <template v-slot:[`item.datestarted`]="{ item }">
          {{new Date(item.datestarted).toLocaleDateString('en-US')}}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
.transparent {
  background: rgba(0, 0, 0, 0);
}
</style>
